import{ apiServiceAWS } from './apiService';

export const getPricingAgreementsForCustomer = (customerName) => {
    return apiServiceAWS.get(`/crm/pricingagreementforcustomer/${customerName}`);
};

export const getProductListForCustomer = (customerName) => {
    return apiServiceAWS.get(`/crm/productlistforcustomer/${customerName}`);
};